/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_timetable.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Timetable */

/**
 * @class this.Controller.Timetable
 */
HafasWebapp.prototype.Controller.Timetable = {

  /** Da das Timetable-Feature z. Zt. nicht über ein Formular zu öffnen ist, gibt es keine Index-Funktion **/

  additionalInstances: {},
  result: {},
  mapContent: { polylines:[], locations:[] },
  selectedInput: Hafas.Config.Timetable.inputOnForm,

  index: function() {
    if(this.Controller.Timetable.selectedInput === "stop") {
      // initial soll eine Haltestelle ausgewählt werden
      Hafas.bind(this.Controller.Timetable.initStopForm, this)();
    } else if(this.Controller.Timetable.selectedInput === "line") {
      // initial soll eine Linie ausgewählt werden
      Hafas.bind(this.Controller.Timetable.initLineForm, this)();
    }
  },

  initStopForm: function() {
    var me = this;
    var controller = me.Controller.Timetable;
    Hafas.bind(me.Controller.Timetable.setSelectedInput, me)("stop");
    var model = {
      toggleInputOnForm: Hafas.Config.Timetable.toggleInputOnForm,
      selectInput: "stop"
    };

    var useFavorites = true;

    model.locationFavorites = useFavorites ? me.Controller.Favorites.instance.getData(1): null;

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Timetable", "index", {});

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ Timetable.index +++ DEBUG Model +++', model)
    }

    var inputValue = me.Controller.Timetable.instance.getLocation("S");
    model.value = inputValue.name || "";

    controller.loadTemplates(function () {
      Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex", model);
      Hafas.bind(me.Controller.Timetable.createStopSuggest, me)();

      // Falls vorhanden (zB bei Browser-Back) die vorherige Haltestelle, Linie und Richtung rendern
      var locResult = Hafas.bind(me.Controller.Timetable.getLocMatchResult, me)();
      if(locResult != null) {
        var line = me.Controller.Timetable.instance.getLineId();
        var direction = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();
        Hafas.bind(me.Controller.Timetable.renderLineSelect, me)({selectedLine: line, direction: direction});
        Hafas.ps.pub('/gui/form/toggle/loading', [{toggle: true}]);

      }
      Hafas.ps.pub('/favorites/update');
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
    });
  },

  initLineForm: function() {
    var me = this;
    var controller = me.Controller.Timetable;
    Hafas.bind(me.Controller.Timetable.setSelectedInput, me)("line");
    var model = {
      line: {},
      toggleInputOnForm: Hafas.Config.Timetable.toggleInputOnForm,
      selectInput: "line"
    };

    var lineResult = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    if(lineResult != null) {
      model.line.value = lineResult.prodResolved.name;
    }

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Timetable", "index", {});

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ Timetable.index +++ DEBUG Model +++', model)
    }

    controller.loadTemplates(function () {
      Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex", model);
      Hafas.bind(me.Controller.Timetable.createLineSuggest, me)();

      // Falls vorhanden (zB bei Browser-Back) die vorherige Linie, Richtung und Haltestellenliste rendern
      if(lineResult != null) {
        var direction = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();
        Hafas.bind(me.Controller.Timetable.renderSelectedLine, me)({direction: direction});
        Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
      }

      Hafas.ps.pub('/favorites/update');
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
    });
  },

  loadTemplates: function (callback) {
    Hafas.Modules.Loader.loadTemplateFiles([
      'timetable.index.html',
      'linesearch.index.html',
      'linesearch.suggest.html',
      'linesearch.atoms.html'
    ], Hafas.bind(function () {
      callback();
    }, this));
  },

  /***********************************************************************************************************/
  /** Linie wird zuerst gesucht **/
  /***********************************************************************************************************/

  createLineSuggest: function () {
    var me = this;
    this.suggest = Hafas.Core.newType("hafasSuggest", {
      input: "HFS_searchTimetableLineInput",
      config: { minChar: 0 },
      suggestMode: 'LineSearch',
      renderTpl: 'LineSearch_TplLineSuggest',
      useFunctionButtons: false,
      onSelect: Hafas.bind(function (line) {
        Hafas.bind(me.Controller.Timetable.processLineInput, me)({line: line});
      }, this)
    });

    // override default behaviour of suggest, because LineSearch is not using locations within suggest
    var overrides = this.suggest.overrides;

    overrides.buildRequestObject = me.Controller.Timetable.linesearch.buildSearchLinesRequestObject;
    overrides.transformHCIData = me.Controller.Timetable.linesearch.transformHCILineSearchData;
    overrides.customMergeFunction = function(_1, _2, sObj) {
      var list = sObj.suggestList;

      // only if there are no suggests, show history and favorites
      if (list.length === 0)
        list = list.concat(sObj.favoriteList).concat(sObj.historyList);

      return list;
    };

    overrides.getHistoryList = function(favoriteData) {
      return favoriteData.linesHistory;
    };
    overrides.getFavoritesList = function(favoriteData) {
      return favoriteData.lines;
    };
    overrides.getTopList = function(){return [];};
  },

  processLineInput: function(params) {
    Hafas.ps.pub('/gui/form/toggle/loading', [{toggle: true}]);
    var me = this;
    var line = params.line;
    Hafas.bind(me.Controller.Timetable.setLineMatchResult, me)(line);
    Hafas.bind(me.Controller.Timetable.renderSelectedLine, me)({});
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if(deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, true);
    }
    // LineDetails für diese Linie abrufen und Haltestellenliste für Direction rendern
    var data = {
      lineId: me.Controller.Timetable.instance.getLineId(),
      callback: function(result) {
        var model = {
          lid: "",
          name: "",
          type: "S"
        };
        Hafas.ps.pub('/timetable/setLocation', [model]);
        if(Hafas.Config.Favorites.addLocationOnSuggest) {
          Hafas.ps.pub('/favorites/addLineToHistory', [result]);
        }
        Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
        Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
      }
    };
    me.Controller.Timetable.instance.searchLineDetails(data);
  },

  renderSelectedLine: function (params) {
    // console.log("+++ renderSelectedLine +++",params);
    var me = this;
    var line = Hafas.bind(this.Controller.Timetable.getLineMatchResult, this)();
    // select first direction *****************************/
    var dirText = line.directions[0].txt;
    if((typeof params != "undefined") && (params.direction)) {
      dirText = params.direction;
    }
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)(dirText);
    this.Controller.Timetable.instance.setDirection(dirText);

    this.Controller.Timetable.instance.setLineId(line.lineId);

    var newVal = line.prodResolved.name;
    Hafas('#HFS_searchTimetableLineInput').value = newVal;

    var label = Hafas('label[for="HFS_searchTimetableLineInput"]');
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', { element: label.textContent, text: newVal }));

    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineDirectionWrapper"),
      template: 'Timetable_TplIndex_DirectionSelect',
      model: {line: line, selectedDirection: dirText, label: Hafas.Modules.i18n.get('common.label.t_N_Direction')},
    }, Hafas.bind(function() {
        Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), true);
        var callback = function(data) {
          Hafas.bind(me.Controller.Timetable.setDirectionText, me)(data.value);
          // Hafas.ps.pub('/timetable/set/stops', [params.value]);
          Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
        };
        Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_TimetableLineDirSelection_Holder', callback: callback}).initiate();
        Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  setSelectedDirectionStops: function() {
    var direction = Hafas.bind(this.Controller.Timetable.getDirectionText, this)();
    var lineResult = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)({direction: direction});
    var locList = lineResult.resolvedLocList;
    var selectedLocation = this.Controller.Timetable.instance.getLocation('S');
    var model = {
      label: Hafas.Modules.i18n.get('Timetable.t_N_searchLabelStop'),
      locList: locList,
      selectedLocation: ""
    };
    if(selectedLocation.name) {
      model.selectedLocation = selectedLocation.name;
    }
    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineStopWrapper"),
      template: 'Timetable_TplIndex_StopSelect',
      model: model,
    }, Hafas.bind(function() {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineStopWrapper"), true);
      var callback = function(params) {
        var selectedOptionId = params.trigger.getAttribute('aria-describedby');
        var optionWrapperData = Hafas("#HFS_TimetableLineStopSelection_Holder #" + selectedOptionId).firstElementChild.dataset;
        // var optionWrapperData = Hafas("#HFS_TimetableLineStopSelection_Holder [data-value='" + params.value + "']").firstElementChild.dataset;
        var model = {
          lid: optionWrapperData.locOption,
          name: optionWrapperData.locName,
          type: "S"
        };
        Hafas.ps.pub('/timetable/setLocation', [model]);
      };
      Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_TimetableLineStopSelection_Holder', callback: callback}).initiate();
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      // Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), false);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  toggleLineFavorite: function (lineId, source, add) {
    var line = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    if (add)
      if (source === 'history')
        Hafas.ps.pub('/favorites/addLineFromHist', [lineId]);
      else
        Hafas.ps.pub('/favorites/addLineToFav', [line]);
    else
      Hafas.ps.pub('/favorites/removeLine',  [lineId]);
  },

  saveLineAsFavorite: function (lineId, source) {
    Hafas.bind(this.Controller.Timetable.toggleLineFavorite, this)(lineId, source, true);
  },

  deleteLineFromFavorite: function (lineId, source) {
    Hafas.bind(this.Controller.Timetable.toggleLineFavorite, this)(lineId, source, false);
  },

  deleteLineInput: function() {
    Hafas.bind(this.Controller.Timetable.GUI.form.toggleFormSelectboxes, this)({idL: ['HFS_LineDirectionWrapper', 'HFS_LineStopWrapper'], show: false});
    Hafas.bind(this.Controller.Timetable.setLineMatchResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setLineDetailsResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)("");
    this.Controller.Timetable.instance.setLineId("");
    var model = {
      lid: "",
      name: "",
      type: "S"
    };
    Hafas.ps.pub('/timetable/setLocation', [model]);
    if(Hafas('#HFS_searchTimetableLineInput')) {
      Hafas('#HFS_searchTimetableLineInput').value = "";
    }
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if(deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, false);
    }
    if(Hafas("#HFS_LineDirectionWrapper")) {
      Hafas("#HFS_LineDirectionWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Direction", {});

    }
    if(Hafas("#HFS_LineStopWrapper")) {
      Hafas("#HFS_LineStopWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Stop", {});
    }
    Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), false);
    Hafas.ps.pub('/app/events/resize');
  },

  /***********************************************************************************************************/
  /** Haltestelle wird zuerst gesucht **/
  /***********************************************************************************************************/

  createStopSuggest: function () {
    var me = this;
    var tmpLoc = me.Controller.Timetable.instance.getLocation();
    me.Controller.Timetable.inpStation = Hafas.Core.newType('hafasSuggest',
        {
          loc: "TimetableStopInput",
          config: {
            suggestType:"S",
            useNearLocation: false
          },
          type: "S"
        });

    if (tmpLoc != null && tmpLoc.name) {
      me.Controller.Timetable.inpStation.setLocation(tmpLoc);
    }
  },

  processStopInput: function(params) {
    Hafas.ps.pub('/gui/form/toggle/loading', [{toggle: true}]);
    var me = this;
    var model = {
      lid: params.loc.lid,
      name: params.loc.name,
      type: "S"
    };
    var histCallback = function(data) {
      if(data.products.length > 0) {
        var result = {location: data.loc, products: data.products};
        var deleteButtonEle = Hafas("[data-timetable-field='delete']");
        if(deleteButtonEle) {
          Hafas.Util.gui.setVisibility(deleteButtonEle, true);
        }
        Hafas.bind(me.Controller.Timetable.setLocMatchResult, me)(result);
        Hafas.bind(me.Controller.Timetable.renderLineSelect, me)({});
      } else {
        alert(Hafas.Modules.i18n.get('Timetable.error.t_N_noProducts'));
      }
    };
    Hafas.ps.pub('/timetable/setLocation', [model]);

    // Fall 1: Die Produkte an der Location wurden schon vom Suggest befüllt
    if(params.productRefList) {
      var products = me.Controller.Timetable.instance.transformSuggestedProductsResult({products: params.productRefList});
      histCallback({loc: model, products: products});
    } else {
      // Fall 2: Die Produkte an der Location wurden nicht gefüllt (Location kommt aus dem Local Storage, weiteren LocDetails abschicken)
      var callback = function(result) {
        this.model = model;
        this.histCallback = histCallback;
        var products = result.svcResL[0].res.locL[0].pRefLResolved;
        var productsResolved = me.Controller.Timetable.instance.transformLocDetailsProductsResult({products: products});
        this.histCallback({loc: this.model, products: productsResolved});
      };
      Hafas.Util.location.getLocDetails(model, callback);
    }
  },

  renderLineSelect: function(params) {
    var me = this;
    var model = Hafas.bind(me.Controller.Timetable.getLocMatchResult, me)();
    var selectedLine;
    if(params && params.selectedLine) {
      selectedLine = params.selectedLine;
    } else {
      selectedLine = model.products[0].prodCtx.lineId;
    }
    model.selectedLine = selectedLine;
    model.label = Hafas.Modules.i18n.get('Timetable.t_N_searchLabelLine');
    var label = Hafas('label[for="TimetableStopInput"]');
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', { element: label.textContent, text: model.location.name }));

    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineSelectionWrapper"),
      template: 'Timetable_TplIndex_LineSelect',
      model: model,
    }, Hafas.bind(function() {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineSelectionWrapper"), true);
      var callback = function(data) {
        // console.log(data);
        // LineDetails für diese Linie abrufen und Haltestellenliste für Direction rendern
        me.Controller.Timetable.instance.setLineId(data.value);
        var model = {
          lineId: data.value,
          callback: function(result) {
            Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
            Hafas.bind(me.Controller.Timetable.renderDirectionSelect, me)();
          }
        };
        me.Controller.Timetable.instance.searchLineDetails(model);
      };
      Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_TimetableLineSelection_Holder', callback: callback}).initiate();
      me.Controller.Timetable.instance.setLineId(selectedLine);
      var model = {
        lineId: selectedLine,
        callback: function(result) {
          Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
          Hafas.bind(me.Controller.Timetable.renderDirectionSelect, me)(params);
        }
      };
      me.Controller.Timetable.instance.searchLineDetails(model);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  renderDirectionSelect: function(params) {
    var me = this;
    var line = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    // select first direction *****************************/
    var dirText = line.directions[0].txt;
    if((typeof params != "undefined") && (params.direction)) {
      dirText = params.direction;
    }
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)(dirText);
    this.Controller.Timetable.instance.setDirection(dirText);

    this.Controller.Timetable.instance.setLineId(line.lineId);

    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineDirectionWrapper"),
      template: 'Timetable_TplIndex_DirectionSelect',
      model: {line: line, selectedDirection: dirText, label: Hafas.Modules.i18n.get('common.label.t_N_Direction')},
    }, Hafas.bind(function() {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), true);
      var callback = function(data) {
        Hafas.bind(me.Controller.Timetable.setDirectionText, me)(data.value);
      };
      Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_TimetableLineDirSelection_Holder', callback: callback}).initiate();
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), false);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  processFavoritesData: function(params) {
    var tempFavData = Hafas.Core.clone(params);
    var processL = ['lines', 'linesHistory'];
    for(var i = 0; i < processL.length; i++) {
      var currentObj = processL[i];
      var currentList = params[currentObj];
      var j = currentList.length;
      while(j--) {
        if(!currentList[j].hasOwnProperty('directions')) {
          tempFavData[currentObj].splice(j, 1);
        }
      }
    }
    return tempFavData;
  },

  addLocationToHistory: function(params) {
    var suggestInstance = Hafas.Modules.Suggest.getSuggestInstanceById('TimetableStopInput');
    if(suggestInstance !== null) {
      // wenn die Location nicht aus der SuggestList zur History hinzugef?gt werden soll, wird sie hier hinzugef?gt
      var prod = null;
      if(suggestInstance.hasOwnProperty('productRef')) {
        prod = suggestInstance.productRef[0].icnClass;
      }
      if(params.prod) {
        prod = params.prod;
      }
      var location = this.Controller.Timetable.instance.getLocation("S");
      if(params.location) {
        location = params.location;
      }
      var name = location.name;
      var lid = location.lid;
      // location zu Verlauf hinzuf?gen
      this.Controller.Favorites.instance.addLocation({lid: lid, name: name, prod: prod}, 'History');
    }
  },

  deleteStopInput: function() {
    Hafas.bind(this.Controller.Timetable.GUI.form.toggleFormSelectboxes, this)({idL: ['HFS_LineSelectionWrapper', 'HFS_LineDirectionWrapper'], show: false});
    Hafas.bind(this.Controller.Timetable.setLineDetailsResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setLocMatchResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)("");
    this.Controller.Timetable.instance.setLineId("");
    var model = {
      lid: "",
      name: ""
    };
    Hafas.ps.pub('/timetable/setLocation', [model]);
    model.type = "S";
    Hafas.ps.pub('/timetable/setLocation', [model]);
    if(Hafas('#TimetableStopInput')) {
      Hafas('#TimetableStopInput').value = "";
    }
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if(deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, false);
    }
    if(Hafas("#HFS_LineSelectionWrapper")) {
      Hafas("#HFS_LineSelectionWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Line", {});
    }
    // Hafas("#HFS_TimetableSubmit").setAttribute("disabled", "disabled");
    Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), false);
    Hafas.ps.pub('/app/events/resize');
  },

  /***********************************************************************************************************/
  /** Ergebnisdarstellung **/
  /***********************************************************************************************************/

  // Laden der Richtungs-Überschrift und Location-List
  showResultOverview: function(params) {
    // console.log("+++ showResultOverview +++", params);
    var me = this;
    var model = {};

    var dirText = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();
    var result = null;
    if(typeof params != "undefined") {
      result = params[0];
    } else {
      result = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)({});
    }
    var journey = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)({direction: dirText});
    var locList = journey.resolvedLocList;
    var lineList = me.Controller.Timetable.instance.getLineList();

    if(Hafas.Modules.History)
      Hafas.Modules.History.addOrUpdateData("Timetable", "result", {additionalContext: 'Timetable', lineId: result.lineId, dirText: dirText});

    if(!Hafas.Config.Favorites.addLocationOnSuggest && (Hafas.bind(me.Controller.Timetable.getSelectedInput, me)() == "stop")) {
      Hafas.bind(me.Controller.Timetable.addLocationToHistory, me)({});
    }

    if(!Hafas.Config.Favorites.addLocationOnSuggest && (Hafas.bind(me.Controller.Timetable.getSelectedInput, me)() == "line")) {
      Hafas.ps.pub('/favorites/addLineToHistory', [result]);
    }

    var mapModel = {
      product: result.prodResolved,
      stopList: locList
    };
    Hafas.bind(me.Controller.Timetable.setProduct, me)(mapModel.product);
    Hafas.bind(me.Controller.Timetable.drawLineToMap, me)(mapModel);

    if(lineList.length > 0) {
      model.line = lineList[0];
    } else {
      model.line = {};
    }
    model.line.prodResolved = result.prodResolved;
    model.line.lineId = result.lineId;
    model.line.locList = locList;
    model.line.dirText = dirText;

    var selectedLocation = me.Controller.Timetable.instance.getLocation('S');
    // Abfahrtstafel für die erste Haltestelle vorladen, wenn keine andere Haltestelle vorgegeben wurde
    model.line.selectedLocation = null;
    if(Hafas.Config.Timetable.preLoadTimetable) {
      model.line.selectedLocation = model.line.locList[1];
      for(var i = 0; i < model.line.locList.length; i++) {
        if(selectedLocation.name == model.line.locList[i].name) {
          model.line.selectedLocation = selectedLocation;
        }
      }
    }
    model.locList = locList;
    // model.line.selectBox = me.Controller.Timetable.getSelectBoxModel(locList);

    // Hafas.bind(me.Controller.Timetable.setLine, me)(model.line);
    // console.log("model", model);
    Hafas.Modules.Render.render({
      file: 'timetable.result.html',
      target: 'Timetable_ResultDetail',
      template: 'Timetable_TplResult',
      model: model
    },Hafas.bind(function(html) {
      // close all open tabs
      Hafas.ps.pub('/GUI/tabs/closeAll');
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{context: 'Timetable'}]);
      Hafas.ps.pub('/app/events/resize');
      if(model.line) {
        // Selectbox für die Auswahl von Stationen initialisieren
        var selectBoxCallback = function (data) {
          Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_schedules']"), true);
          var selectedOptionId = data.trigger.getAttribute('aria-describedby');
          var optionWrapperData = Hafas("#HFS_TimetableSelectBoxHolder #" + selectedOptionId).firstElementChild.dataset;
          var model = {
            lid: optionWrapperData.locOption,
            extId: optionWrapperData.locExtid,
            name: optionWrapperData.locName,
            type: "S"
          };
          Hafas.ps.pub('/timetable/result/load', [{location: model}]);
        };
        Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_TimetableSelectBoxHolder', callback: selectBoxCallback}).initiate();
        if(Hafas.Config.Timetable.preLoadTimetable && model.line.selectedLocation.hasOwnProperty('extId')) {
          model.line.selectedLocation.type = "S";
          Hafas.ps.pub('/timetable/result/load', [{location: model.line.selectedLocation}]);
        }
      }
      // hide form
      Hafas.ps.pub('/GUI/form/hide', [{ appcontext: 'LineSearch' }]);
    },this));

	},

  renderTimetableTable: function(params) {
    console.log("+++ renderTimetableTable +++", params);
    var me = this;
    var target = Hafas("[data-result-container='timetable']");
    var model = {
      dataAttribute: "data-overlay-target='loader_schedules'",
      label: Hafas.Modules.i18n.get('Timetable.t_N_allDepartures')
    };
    var hasResult = true;
    var template = "Timetable_TplDirectionResults";
    if(params.length > 0) {
      model = params[0].directionsList[0];
    } else {
      template = "Timetable_TplDirectionNoResults";
      hasResult = false;
    }
    var lineId = me.Controller.Timetable.instance.getLineId();
    var product = Hafas.bind(me.Controller.Timetable.getProduct, me)();
    me.Controller.Timetable.result = model;
    me.Controller.Timetable.result.prodResolved = product;
    me.Controller.Timetable.result.dirText = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();

    Hafas("#HFS_TimetableSelectBox_Option_0").setAttribute("aria-disabled", true);

    Hafas.Modules.Render.render({
      file: 'timetable.result.html',
      target: target,
      template: template,
      model: model
    },Hafas.bind(function(html) {
      if(hasResult) {
        Hafas.ps.pub('/gui/common/showLoader', [false]);
        var location = me.Controller.Timetable.instance.getLocation("S");
        if(location.hasOwnProperty('extId')) {
          Hafas.bind(me.Controller.Timetable.setActiveStation, me)(location.extId);
        }
        // Abfahrten nur anzeigen, wenn Abfahrten-Feature angeschaltet
/*        if(Hafas.Config.Timetable.showNextDepartures) {
          Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_departures']"), true);
          Hafas.bind(me.Controller.Timetable.searchNextDepartures, me)(location);
        }*/
      }
      if(Hafas("#HFS_TimtableTabsWrapper")) {
        var callback = function() {
          Hafas.ps.pub('/app/events/resize');
        };
        Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_TimtableTabsWrapper', callback: callback}).initiate();
      } else {
        Hafas.ps.pub('/app/events/resize');
      }
      // Hafas.ps.pub('/gui/common/showLoader', [false, 'loader_schedules']);
      Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_schedules']"), false);
    },this));
  },

  selectStation: function() {
    var selectedLocation = this.Controller.Timetable.instance.getLocation('S');
    Hafas.ps.pub('/sq/searchFromOtherContext', [{location:{name:selectedLocation.name, lid:selectedLocation.lid}}, "dep"]);
    Hafas.ps.pub('/app/events/closeResults', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
  },

  jumpinTimetable: function() {
    var dirTxt = Hafas.bind(this.Controller.Timetable.getDirectionText, this)();
    var lineId = this.Controller.Timetable.instance.getLineId();
    Hafas.ps.pub('/timetable/linesearch/jumpin', [{ lineId: lineId, dirText: dirTxt}]);
  },

  setSelectedInput: function(input) {
    this.Controller.Timetable.selectedInput = input;
  },

  getSelectedInput: function() {
    return this.Controller.Timetable.selectedInput;
  },

	setDirectionText: function(txt) {
    this.Controller.Timetable.currentDirection = txt;
	},

	getDirectionText: function() {
  	var txt = "";
  	if(this.Controller.Timetable.hasOwnProperty('currentDirection')) {
  		txt = this.Controller.Timetable.currentDirection;
		}
  	return txt;
	},

  setLocMatchResult:function(result) {
    this.Controller.Timetable.currentLocInfo = result;
  },

  getLocMatchResult: function() {
    return this.Controller.Timetable.currentLocInfo || null;
  },

  setLineMatchResult: function(line) {
    this.Controller.Timetable.currentLine = line;
  },

  getLineMatchResult: function() {
    return this.Controller.Timetable.currentLine || null;
  },

  setProduct: function(product) {
    this.Controller.Timetable.currentProduct = product;
  },

  getProduct: function() {
    return this.Controller.Timetable.currentProduct || null;
  },

  setLineDetailsResult: function(result) {
    // console.log("+++ setLineDetailsResult +++", result);
    this.Controller.Timetable.currentLineResult = result;
  },

  getLineDetailsResult: function(params) {
    var lineResult = this.Controller.Timetable.currentLineResult;
    if(typeof params == "undefined") {

    } else {
      if(params.hasOwnProperty('direction')) {
        var selectedJny = null;
        for(var i = 0; i < lineResult.resolvedJnyList.length; i++) {
          if(lineResult.resolvedJnyList[i].dirText == params.direction) {
            selectedJny = lineResult.resolvedJnyList[i];
            break;
          }
        }
      }
      if(selectedJny != null) {
        lineResult = selectedJny;
      }
    }
    return lineResult;
  },

  // Wird nicht mehr verwendet, stattdessen wird direkt auf die Abfahrtstafel verlinkt /mroe
/*  searchNextDepartures: function(location) {
    // this.Controller.SQ.instance.id = "timetable";
    this.Controller.SQ.instance.setLocation({name: location.name, lid: location.lid});
    this.Controller.SQ.instance.search();
  },

  showNextDepartures: function () {
    // console.log("+++ showNextDepartures +++");
    var result = this.Controller.SQ.instance.getResultData();

    // Alle Journeys außer der Timetable Linie+Richtung aussortieren
    var currentDir = this.Controller.Timetable.instance.getDirection();
    var lineName = (Hafas.bind(this.Controller.Timetable.getLine, this)()).product.name;
    var lineCls = "";
    var hasResults = true;
    var journeys = result.resolvedData.groupedJourney;
    for(var cls in journeys) {
      var trsfData = journeys[cls].transformedData;
      var dataIdx = trsfData.length;
      if(dataIdx == 0) {
        delete result.resolvedData.groupedJourney[cls];
      }
      while(dataIdx--) {
        if (trsfData[dataIdx].product.name != lineName) {
          trsfData.splice(dataIdx, 1);
        } else {
          lineCls = cls;
        }
      }
      for(var trsfIdx = 0; trsfIdx < trsfData.length; trsfIdx++) {
        var dirIdx = trsfData[trsfIdx].directions.length;
        while(dirIdx--) {
          var removeFormatDir = trsfData[trsfIdx].directions[dirIdx].direction.replace("\<wbr\>", "");
          if(removeFormatDir != currentDir) {
            trsfData[trsfIdx].directions.splice(dirIdx, 1);
          }
        }
        if(trsfData[trsfIdx].directions.length == 0) {
          hasResults = false;
        }
      }
    }
    var targetContainer = Hafas('[data-timetable-container="departures"]', false);
    var sqResultTpl = 'Timetable_TplResultJourneyGrouped';

    var model = {
      dataAttribute: "data-overlay-target='loader_departures'",
      label: Hafas.Modules.i18n.get('Timetable.t_N_nextDepartures')
    };
    if(result.resolvedData.groupedJourney[lineCls]) {
      model = result.resolvedData.groupedJourney[lineCls];
    } else {
      hasResults = false;
    }
    if (!hasResults) {
      sqResultTpl = 'Timetable_TplDirectionNoResults';
      targetContainer = Hafas('[data-timetable-container="departure_wrapper"]', false);
    }
    if (targetContainer) {
      Hafas.Modules.Render.render({
        file: 'sq.result.lineGroup.html',
        target: targetContainer,
        template: sqResultTpl,
        model: model
      }, function () {
        Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_departures']"), false);
        var wrapper = Hafas("[data-timetable-container='departure_wrapper']");
        if(wrapper) {
          Hafas.Util.gui.setVisibility(wrapper, true);
        }
      });
    }
    Hafas.ps.pub('/app/events/resize');
  },*/

  GUI: {
    form: {
      toggleFormSelectboxes: function(params) {
        var idList = params.idL;
        for(var i = 0; i < idList.length; i++) {
          var ele = Hafas("#" + idList[i]);
          if(ele) {
            Hafas.Util.gui.setVisibility(ele, params.show);
          }
        }
      },
      toggleLoadingView: function(params) {
        var currentView = Hafas.bind(this.Controller.Timetable.getSelectedInput, this)();
        var boolval = params.toggle;
        if(params.hasOwnProperty('ids')) {
          for(var i = 0; i < params.ids.length; i++) {
            Hafas.Util.gui.setVisibility(Hafas("#" + params.ids[i]), boolval);
          }
        } else {
          Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), boolval);
          Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), boolval);
          Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), boolval);
          if(currentView === "line") {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_LineStopWrapper"), boolval);
          } else if(currentView == "stop") {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_LineSelectionWrapper"), boolval);
          }
        }
        Hafas.ps.pub('/app/events/resize');
      }
    },
    common: {
      showLoader: function(bool, target) {
        var loaderOverlay = Hafas("[data-overlay='loader']", true);
        for(var i = 0; i < loaderOverlay.length; i++) {
          if(bool) {
            loaderOverlay[i].style.display = "block";
          } else {
            loaderOverlay[i].style.display = "none";
          }
        }
        // Wenn es mehrere Loader in der view gibt
        if(target) {
          for(var i = 0; i < loaderOverlay.length; i++) {
            loaderOverlay[i].style.display = "none";
          }
          var targetC = Hafas("[data-overlay-target='" + target + "']");
          if(targetC) {
            targetC.style.display = "block";
          }
        }
      }
    }
  },

  // TODO: in Map controller auslagern, weiß aber noch nicht wie

  drawLineToMap: function(params) {
    // console.log("+++ drawLineToMap +++", params);
    Hafas.ps.pub('/map/closeAllToolboxItems',[]);
    this.Controller.Timetable.mapContent.polylines = [];
    if(Hafas.Config.Switches.useLineSearch) {
      Hafas.bind(this.Controller.LineSearch.hideLineDetails, this.Controller.LineSearch)();
    }
    var stopList = params.stopList;
    var product = params.product;
    // Hafas.ps.pub('/common/result/journey',[journey]);
    // this.clearMap();
    var map =  this.Controller.Map.instance;
    var polylineData = Hafas.bind(this.Controller.Timetable.createPolylineFromStopList, this)(stopList);

    var polylineColors = product.icoResolved;
    var polylineParams = {
      color: polylineColors.bg,
      zIndex: 120,
      border: Hafas.Config.Maps.useLineBorders,
      borderColor: Hafas.Config.Maps.LINE_BORDER_COLOR,
      useArrows: true,
      opacity: 1,
      width: 5
    };
    // console.log("polylineData", polylineData);

    this.Controller.Timetable.mapContent.polylines.push(Hafas.Util.maps.showHCIPolyline(polylineData, map, polylineParams));

    for (var i = 0; i < stopList.length; i++) {
      if(stopList[i].crd) {
        var loc = stopList[i];
        var icon = product.icoResolved;
        var html = "<span id='HFS_locLabel_" + loc.extId + "' class='hfs_stationName' data-extId='" + loc.extId + "'>" + loc.name + "</span>";
        this.Controller.Timetable.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, {
          type: "container",
          html: html
        }, false, {backgroundColor: icon.bg}));

        this.Controller.Timetable.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, null, false, {backgroundColor: icon.bg}));
      }
    }

    var stationLabels = Hafas("#HFS_PageMap .hfs_stationName", true);

    // Labels auf der Karte bis auf Start- und Endpunkt ausblenden
    for(var j = 0; j < stationLabels.length; j++) {
      if(j != 0 && j != stationLabels.length - 1)
        stationLabels[j].parentNode.style.display = "none";
    }

    map.centerToContent(this.Controller.Timetable.mapContent.polylines[0]);
  },

  createPolylineFromStopList: function(stopList) {
    var coodList = [];
    for(var i = 0; i < stopList.length; i++) {
      if(stopList[i].crd) {
        var stop = stopList[i];
        coodList.push(Hafas.Util.geo.hciCrdToHafasCoord(stop.crd));
      }
    }
    return coodList;
  },

  setActiveStation: function(extId) {
    var currentStation = this.Controller.Timetable.instance.getStopFromList(extId);

    var mapStationLabels = Hafas("#HFS_PageMap .hfs_active", true);
    for (var i = 0; i < mapStationLabels.length; i++) {
      mapStationLabels[i].removeClassName('hfs_active');
      mapStationLabels[i].parentNode.style.display = "none";
    }

    try {
     var mapNodes = Hafas("#HFS_locLabel_" + extId, true);
      for(var i = 0; i < mapNodes.length; i++) {
        mapNodes[i].parentNode.style.display = "";
        mapNodes[i].addClassName("hfs_active");
      }
    }
    catch(e) {
      console.error(e);
    }
    // Flyout zu der ausgewählten Station anzeigen
    Hafas.ps.pub('/map/clickOnLocation', [this.Controller.Map.instance, currentStation, null, {}]);
    Hafas.bind(this.Controller.Timetable.zoomMapToStation, this)(currentStation);
  },

  zoomMapToStation: function(station) {
    function getCoordFromStation(s) {
      return Hafas.Core.newType("hafasCCoord", {
        lat: s.crd.y,
        lon: s.crd.x
      })
    }
    this.Controller.Map.instance.centerToGeo(getCoordFromStation(station), Hafas.Config.Maps.searchPredefinedZoom);
  },

  clearMap: function() {
    var map =  this.Controller.Map.instance;
    for(var i = 0; i < this.Controller.Timetable.mapContent.polylines.length; i++)
    {
      map.hideContent(this.Controller.Timetable.mapContent.polylines[i]);
      map.removeContent(this.Controller.Timetable.mapContent.polylines[i]);
    }

    for(var i = 0; i < this.Controller.Timetable.mapContent.locations.length; i++)
    {
      map.hideContent(this.Controller.Timetable.mapContent.locations[i]);
      map.removeContent(this.Controller.Timetable.mapContent.locations[i]);
    }

    this.Controller.Timetable.mapContent.polylines = [];
    this.Controller.Timetable.mapContent.locations = [];
  },

  closeView: function(histData) {
    // console.log("+++ closeView +++", histData);
    switch(histData.view)
    {
      case "index":
        break;
      case "result":
        Hafas.ps.pub('/app/events/closeResults', [{}]);
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView: function(histData) {
    var view = histData.view;
    switch(view) {
      case "index":
        // Hafas.bind(this.Controller.Timetable.cleanup, this)();
        Hafas.ps.pub('/map/closeAllToolboxItems');
        Hafas.bind(this.Controller.Timetable.clearMap, this)();
        Hafas.ps.pub('/app/events/closeResults', [{}]);
        Hafas.bind(this.Controller.Timetable.index, this)();
        Hafas.ps.pub('/GUI/form/show', [{}]);
        break;
      case "result":
        if(histData.data.hasOwnProperty('lineId')) {
          this.Controller.Timetable.instance.setLineId(histData.data.lineId);
        }
        if(histData.data.hasOwnProperty('dirText')) {
          Hafas.bind(this.Controller.Timetable.setDirectionText, this)(histData.data.dirText);
        }
        Hafas.ps.pub('/timetable/jumpin');
        break;
    }
  },

  cleanup: function () {
    // console.log("+++ cleanup +++");
    Hafas.ps.pub('/map/closeAllToolboxItems');
    Hafas.bind(this.Controller.Timetable.clearMap, this)();
    Hafas.bind(this.Controller.Timetable.deleteStopInput, this)();
    Hafas.bind(this.Controller.Timetable.deleteLineInput, this)();
    // Hafas.bind(this.Controller.Timetable.setLineMatchResult, this)(null);
    // Hafas.bind(this.Controller.Timetable.setLineDetailsResult, this)(null);
    //  Hafas.bind(this.Controller.Timetable.setDirectionText, this)("");

    // Vorübergehend auskommentiert
    //Hafas.ps.pub('/app/events/closeResults', [{}]);

    // GUI Funktionen aus Controller.App.events.closeResults übernommen (zu prüfen)
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/all/hide', [{}]);


    Hafas.ps.pub('/GUI/results/overview/removeActive', [{arrayIdx: null}]);
    Hafas.ps.pub('/GUI/results/additional/hideAll');
    Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
  }
};
